import { Component } from '@cms-max/medicare-api-sdk'
import { ClickableCardLink, ClickableCardButton } from 'components/ClickableCard'
import { IconLock } from 'components/Icon/IconLock'
import { IconSquares } from 'components/Icon/IconSquares'
import { MyLink } from 'components/MyLink'
import { useMedicareUrl } from 'hooks/useMedicareUrl'
import { LanguagePreference } from 'models/LanguagePreference'
import { useTranslation } from 'react-i18next'
import { callPrivacySetting } from 'utils/privacy-settings'

export const DataSharing = () => {
  const { t, i18n } = useTranslation('accountSettings')
  const connectedAppsUrl = useMedicareUrl(
    'https://www.medicare.gov/mbp/connectedapps.aspx',
    'https://www.medicare.gov/mbp/connectedapps.aspx?Lang=es-mx'
  )
  const deleteAccountUrl = useMedicareUrl(
    'https://www.medicare.gov/mbp/deactivate.aspx',
    'https://www.medicare.gov/mbp/deactivate.aspx?Lang=es-mx'
  )
  const component = Component.AccountSettings

  return (
    <div className='ds-l-row'>
      <div className='ds-l-col--12'>
        <h2 className='ds-text-heading--xl'>{t('paragraph.dataSharing.title')}</h2>
      </div>
      <div className='ds-l-col--12 my-u-max-width-md'>
        <div className='ds-l-row'>
          <div className='ds-l-col--12 ds-l-sm-col--6 my-u-pt--12'>
            <ClickableCardButton
              icon={<IconLock />}
              onClick={() => callPrivacySetting(i18n.language as LanguagePreference)}
              siteActivityProps={{
                core: {
                  component,
                  elementId: 'accountsettings_privacy_click',
                  coreClickData: {
                    linkText: t('paragraph.dataSharing.privacySettings')
                  }
                }
              }}
            >
              {t('paragraph.dataSharing.privacySettings')}
            </ClickableCardButton>
          </div>
          <div className='ds-l-col--12 ds-l-sm-col--6 my-u-pt--12'>
            <ClickableCardLink
              icon={<IconSquares />}
              href={connectedAppsUrl}
              siteActivityProps={{
                core: {
                  component,
                  elementId: 'accountsettings_connectedapps_click',
                  coreClickData: {
                    linkText: t('paragraph.dataSharing.myConnectedApps'),
                    linkUrl: connectedAppsUrl
                  }
                }
              }}
            >
              {t('paragraph.dataSharing.myConnectedApps')}
            </ClickableCardLink>
          </div>
        </div>
        <div className='ds-l-col--12 my-u-pt--18 my-u-pb--20'>
          <MyLink
            href={deleteAccountUrl}
            siteActivityProps={{
              core: {
                component,
                elementId: 'accountsettings_deleteaccount_click',
                coreClickData: {
                  linkText: t('paragraph.dataSharing.deleteAccountLinkText'),
                  linkUrl: deleteAccountUrl
                }
              }
            }}
          >
            {t('paragraph.dataSharing.deleteAccountLinkText')}
          </MyLink>
        </div>
      </div>
    </div>
  )
}
